export class LiveTickerHelper
{
  public static showLiveticker(databaseId: number, eventId: number): void
  {
    const url = 'https://live.3k-darts.com/event/' + databaseId + '/' + eventId;
    window.open(url, '_blank').focus();
  }

  public static showLivetickerTeamLeague(databaseId: number, parentMatchId: number): void
  {
    const url = 'https://live.3k-darts.com/event/' + databaseId + '/' + parentMatchId;
    window.open(url, '_blank').focus();
  }
}
